import Role from "./role";
/**
 * A UserRole
 * @param {string} name - Name
 * @param {string} weez_orga_id - Weezevent ID
 * @returns {Class} - Role instance
 */
class UserRole {
	constructor({
		context,
		role,
	} = {}) {
		this._context = context;
		this._role = new Role(role);
	}

	getKey() {
		return '';
	}

	getLevel() {
		return parseInt(this._context && this._context.level);
	}

	getValue() {
		return parseInt(this._context && this._context.value);
	}

	getRole() {
		return this._role;
	}
}
export default UserRole;
